import { SchedulerGridScheduleProps } from './types';
import { ReactNode, useState } from 'react';
import { SchedulerGridScheduleElement } from './element';
import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { useAccess } from '@hooks/access';

export const SchedulerGridSchedule = ({
  data,
  reschedulable = true,
}: SchedulerGridScheduleProps) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const access = useAccess();

  const withTooltip = (component: ReactNode) =>
    isTruncated ? (
      <AppTooltip
        className="w-fit max-w-fit p-0.5"
        side="top"
        context={
          <SchedulerGridScheduleElement
            data={data}
            tooltip
            reschedulable={reschedulable && !access.readOnly}
          />
        }>
        {component}
      </AppTooltip>
    ) : (
      component
    );

  return withTooltip(
    <div>
      <SchedulerGridScheduleElement
        data={data}
        setIsTruncated={setIsTruncated}
        reschedulable={reschedulable}
      />
    </div>,
  );
};
